const rolls = {
    VAL: {
        COUNSELOR: 1,
        ADVISER: 2,
        CO_MANAGER: 3,
        BIS_MANAGER: 4,
        SYS_ADMIN: 7,
    },
    NAME: {
        COUNSELOR: 'カウンセラー',
        ADVISER: 'アドバイザー',
        CO_MANAGER: 'CO管理者',
        BIS_MANAGER: '業務管理者',
        SYS_ADMIN: 'システム管理者',
    },
    LIST: [],
};
rolls.LIST.push({ value: rolls.VAL.COUNSELOR, text: rolls.NAME.COUNSELOR });
rolls.LIST.push({ value: rolls.VAL.ADVISER, text: rolls.NAME.ADVISER });
rolls.LIST.push({ value: rolls.VAL.CO_MANAGER, text: rolls.NAME.CO_MANAGER });
rolls.LIST.push({ value: rolls.VAL.BIS_MANAGER, text: rolls.NAME.BIS_MANAGER });
rolls.LIST.push({ value: rolls.VAL.SYS_ADMIN, text: rolls.NAME.SYS_ADMIN });

const privileges = {
    VAL: {
        SYSTEM_ADMIN:       1 << 0,     // 以下のすべてが行える特別フラグ
        ACCOUNT_EDIT:       1 << 1,     // アカウントの編集(システム管理者以外)
        ACCOUNT_DELETE:     1 << 2,     // アカウントの削除(システム管理者と自身以外)
        ALERT_ALL:          1 << 3,     // 全てのアラート閲覧可能・検索可能
        ALERT_SHOP_ALL:     1 << 4,     // 自身の所属店舗の会員のアラートが閲覧可能
        ALERT_OWN:          1 << 5,     // 自身の担当会員のアラートが閲覧可能
        ALERT_STOP:         1 << 6,     // アラートを停止可能
        SEND_CS:            1 << 7,     // コネクトシップへ会員情報送信可能
        SEND_CS_TEST:       1 << 8,     // コネクトシップテスト環境へ会員情報送信可能
        CUSTOMER_ALL:       1 << 9,     // 他店舗の会員情報閲覧可能
        CUSTOMER_CREATE:    1 << 10,    // 会員の登録処理可能
        CUSTOMER_DELETE:    1 << 11,    // 会員の削除(初入会キャンセル時や間違って登録したものを削除)
        CUSTOMER_EXIT:      1 << 12,    // 会員の退会処理可能
        REQUEST_MOD_COURSE: 1 << 13,    // 会員の契約内容の修正依頼可能
        HISTORY_DELETE:     1 << 14,    // 経緯表の削除可能
        COUNSELOR:          1 << 15,    // 会員の担当COになることが可能
        ADVISER:            1 << 16,    // 会員の担当ADになることが可能
        UPDATE_RESPONSIBLE: 1 << 17,    // 担当変更可能
        CONTRACT_EDIT:      1 << 18,          // 契約書編集
    },
    NAME: {
        SYSTEM_ADMIN:       "システム管理者",
        ACCOUNT_EDIT:       "アカウント編集",
        ACCOUNT_DELETE:     "アカウント削除",
        ALERT_ALL:          "全アラート",
        ALERT_SHOP_ALL:     "所属店アラート",
        ALERT_OWN:          "担当会員アラート",
        ALERT_STOP:         "会員アラート停止",
        SEND_CS:            "コネクトシップ送信",
        SEND_CS_TEST:       "コネクトシップ送信(テスト環境)",
        CUSTOMER_ALL:       "他支店会員管理",
        CUSTOMER_CREATE:    "会員登録",
        CUSTOMER_DELETE:    "会員削除",
        CUSTOMER_EXIT:      "会員退会",
        REQUEST_MOD_COURSE: "契約修正依頼",
        HISTORY_DELETE:     "経緯表削除",
        COUNSELOR:          "CO業務",
        ADVISER:            "AD業務",
        UPDATE_RESPONSIBLE: "担当変更",
        CONTRACT_EDIT:      "契約書編集",
    },
    LIST: [],
};
//privileges.LIST.push({ value: privileges.VAL.SYSTEM_ADMIN, text: privileges.NAME.SYSTEM_ADMIN });
privileges.LIST.push({ value: privileges.VAL.ACCOUNT_EDIT, text: privileges.NAME.ACCOUNT_EDIT });
privileges.LIST.push({ value: privileges.VAL.ACCOUNT_DELETE, text: privileges.NAME.ACCOUNT_DELETE });
privileges.LIST.push({ value: privileges.VAL.ALERT_ALL, text: privileges.NAME.ALERT_ALL });
privileges.LIST.push({ value: privileges.VAL.ALERT_SHOP_ALL, text: privileges.NAME.ALERT_SHOP_ALL });
privileges.LIST.push({ value: privileges.VAL.ALERT_OWN, text: privileges.NAME.ALERT_OWN });
privileges.LIST.push({ value: privileges.VAL.ALERT_STOP, text: privileges.NAME.ALERT_STOP });
privileges.LIST.push({ value: privileges.VAL.SEND_CS, text: privileges.NAME.SEND_CS });
privileges.LIST.push({ value: privileges.VAL.SEND_CS_TEST, text: privileges.NAME.SEND_CS_TEST });
privileges.LIST.push({ value: privileges.VAL.CUSTOMER_ALL, text: privileges.NAME.CUSTOMER_ALL });
privileges.LIST.push({ value: privileges.VAL.CUSTOMER_CREATE, text: privileges.NAME.CUSTOMER_CREATE });
privileges.LIST.push({ value: privileges.VAL.CUSTOMER_DELETE, text: privileges.NAME.CUSTOMER_DELETE });
privileges.LIST.push({ value: privileges.VAL.CUSTOMER_EXIT, text: privileges.NAME.CUSTOMER_EXIT });
privileges.LIST.push({ value: privileges.VAL.REQUEST_MOD_COURSE, text: privileges.NAME.REQUEST_MOD_COURSE });
privileges.LIST.push({ value: privileges.VAL.HISTORY_DELETE, text: privileges.NAME.HISTORY_DELETE });
privileges.LIST.push({ value: privileges.VAL.COUNSELOR, text: privileges.NAME.COUNSELOR });
privileges.LIST.push({ value: privileges.VAL.ADVISER, text: privileges.NAME.ADVISER });
privileges.LIST.push({ value: privileges.VAL.UPDATE_RESPONSIBLE, text: privileges.NAME.UPDATE_RESPONSIBLE });
privileges.LIST.push({ value: privileges.VAL.CONTRACT_EDIT, text: privileges.NAME.CONTRACT_EDIT });

export default {
    ROLL: rolls,
    PRIVILEGE: privileges,
}